import { useTranslation } from 'react-i18next';

import { Badge, IconButton, Text, Tooltip } from '@fly/core';
import { downloadFile } from '@fly/shared';
import { FlyCopyButton } from '@fly/shared-ui';
import { FlySvgSprite } from '@fly/svg';

import { ArtifactFile } from '../../../../store/registry.transformers';

function getDownloadUrl(url: string | undefined | null) {
  if (!url) {
    return null;
  }
  try {
    return `${window.location.origin}${new URL(url).pathname}`;
  } catch (error) {
    return null;
  }
}

export function FileRow({ file }: { file: ArtifactFile }) {
  const { t } = useTranslation();

  const downloadUrl = getDownloadUrl(file.url);

  return (
    <div
      className='min-w-0 group flex items-center gap-fly-2'
      data-testid='file-row'
    >
      <FlySvgSprite name='file' size={12} />
      <Text
        size='1'
        color='neutral'
        weight='medium'
        highContrast
        className='min-w-0 truncate'
      >
        {file.fileName}
      </Text>
      {file.isPublic && (
        <Tooltip
          content={t(
            'app.dashboard.artifacts.distribution_popover.download_count',
            {
              count: file.downloadCount,
            }
          )}
        >
          <Badge
            iconStart='download'
            color='neutral'
            className='h-[20px]'
            variant='soft'
          >
            {file.downloadCount}
          </Badge>
        </Tooltip>
      )}
      {file.url && downloadUrl && (
        <div className='flex items-center gap-fly-2 opacity-0 transition-opacity group-hover:opacity-100 focus-within:opacity-100'>
          {file.isPublic && (
            <Tooltip
              content={t(
                'app.dashboard.artifacts.distribution_popover.copy_link'
              )}
            >
              <FlyCopyButton code={file.url} />
            </Tooltip>
          )}
          <Tooltip content={t('app.common.actions.download')}>
            <IconButton
              icon='download'
              aria-label={t('app.common.actions.download')}
              size='1'
              color='neutral'
              variant='ghost'
              onClick={() => {
                downloadFile(downloadUrl);
              }}
            />
          </Tooltip>
        </div>
      )}
    </div>
  );
}
